import { generateId } from '../helpers/generateId';
import { getCookie } from '../helpers/getCookie';
import { cleanUrlEncodedValue } from '../helpers/cleanUrlEncodedValue';
import { safeLocalStorage } from '../storage/safeLocalStorage';

export const getRidAnmId = () => {
  let ridAnmId = safeLocalStorage.getItem('_rid_anm_id');

  if (!ridAnmId) {
    ridAnmId = getCookie('_rid_anm_id') || null;
  }

  if (!ridAnmId) {
    ridAnmId = '0000' + generateId(28);
  }

  const cleaned = cleanUrlEncodedValue(ridAnmId);
  return cleaned !== null ? cleaned : ridAnmId;
};

export default getRidAnmId;
